import { InfoOutlined } from '@mui/icons-material';
import { TextField, TextFieldProps, Tooltip, InputAdornment } from '@mui/material';
import React from 'react';

export type TextFieldWithTooltipProps = TextFieldProps & {
  tooltip?: string;
};

export default function TextFieldWithTooltip({ tooltip, InputProps: legacyInputProps, ...props }: TextFieldWithTooltipProps) {
  return (
    <TextField
      {...props}
      InputProps={{
        ...legacyInputProps,
        ...(tooltip && {
          endAdornment: (
            <>
              <InputAdornment position="end">
                <Tooltip title={tooltip}>
                  <InfoOutlined fontSize="small" />
                </Tooltip>
              </InputAdornment>
              {legacyInputProps?.endAdornment}
            </>
          ),
        }),
      }}
    />
  );
}
